import { useAppSelector } from 'store/hooks';

import { AiScribeDrawer } from './drawer';

const AiScribe = () => {
  const { state } = useAppSelector((s) => s.clients.aiScribe);

  if (state == null) return null;

  return <AiScribeDrawer />;
};

export default AiScribe;
